const publicBase = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
const root = `${publicBase}skins/oro-mx-h5/currency`;

/** 源站 BRL.png / BONUS.png，已镜像到本地。现金可提现，星币不可提现。 */
export const oroMxCurrencyAssets = {
  bonus: `${root}/bonus.png`,
  cash: `${root}/cash.png`,
} as const;
